import { GENEMO_LEGAL_LINKS, GENEMO_OPERATOR } from '../lib/genemoApps'

/** 画面の一番下：運営者と規約のリンク（DESIGN-SYSTEM.md の Shell 節 ⑤。ログイン前の画面にも出す） */
export function LegalFooter() {
  return (
    <footer className="gm-footer">
      <span>運営: {GENEMO_OPERATOR}</span>
      {GENEMO_LEGAL_LINKS.map(l => <a key={l.url} href={l.url} target="_blank" rel="noreferrer">{l.label}</a>)}
    </footer>
  )
}
